import React from "react";

const ChevronRight = props => (
  <svg viewBox="0 0 7 13" fill="none" {...props}>
    <path
      d="M.465.262L.273.453a.315.315 0 000 .465L5.605 6.25.273 11.61a.315.315 0 000 .464l.192.192a.315.315 0 00.465 0l5.77-5.77a.315.315 0 000-.465L.93.261a.315.315 0 00-.465 0z"
      fill="currentColor"
    />
  </svg>
);

export default ChevronRight;
